import { BaseTypeSchema } from "../BaseTypeSchema";
import { VariableType } from "../VariableType";

export class FontSchema extends BaseTypeSchema
{
    constructor(required: boolean)
    {
        super(VariableType.Font, required);
    }
}